import { AuthLayout } from "@/components/ui/auth-layout";
import { Panel } from "@/components/ui/panel";
import { Heading } from "@/components/ui/heading";
import { Text, Muted } from "@/components/ui/text";

export default function MaintenanceRoute() {
  return (
    <AuthLayout>
      <Panel padding="lg" className="space-y-6">
        {/* Logo */}
        <div className="flex justify-center">
          <img src="/logo-inverted-20260129.svg" alt="Rollforward" className="h-12 w-auto" />
        </div>

        {/* Content */}
        <div className="text-center space-y-4">
          <Heading size="lg">We&apos;ll be right back</Heading>
          <Text>
            Rollforward is currently undergoing scheduled maintenance. We&apos;ll be back online
            shortly. Thank you for your patience.
          </Text>
        </div>

        {/* Support info */}
        <div className="rounded-lg bg-muted p-4 text-center">
          <Muted>
            If you need immediate assistance, please contact support at{" "}
            <a
              href="mailto:support@rollforward.com"
              className="text-foreground underline hover:no-underline"
            >
              support@rollforward.com
            </a>
          </Muted>
        </div>
      </Panel>
    </AuthLayout>
  );
}
